.badge {
    svg {
        vertical-align: middle;
    }
    
}